import _ from 'lodash'

export interface RowsAPI {
	count: () => number
	getRowAbove: (y: number) => number
	first: () => number
	last: () => number
	get: (index: number) => number
	setNoWedge: () => void
	isWedgePossible: () => boolean
	closeRow: (rowBottom: number) => void
	markRowWithContent: () => void
	createExtraRows: (rowStart: number, rowBottom: number) => void
}

export class RowsLimitError extends Error {
	// @ts-ignore
	constructor(message?) {
		super(message)
		Object.setPrototypeOf(this, RowsLimitError.prototype)
	}
}

export const create = (gridTop: number, { rowsLimit }: { rowsLimit?: number }): RowsAPI => {
	const rowsTops: Array<number> = [gridTop]
	const maxSpanByRow: { [line: string]: number } = {}
	const rowsTopsWedgeUnavailable: { [rowTop: string]: boolean } = {}

	const isRowWithContent = () => !!maxSpanByRow[rowsTops.length]

	const rowsAPI: RowsAPI = {
		count: () => rowsTops.length,
		// @ts-ignore
		first: () => _.first(rowsTops),
		// @ts-ignore
		last: () => _.last(rowsTops),
		get: (index) => rowsTops[index],
		closeRow: (rowBottom) => {
			// @ts-ignore
			if (rowsTops.length + 1 >= rowsLimit) {
				throw new RowsLimitError()
			}

			rowsTops.push(rowBottom)
		},
		getRowAbove: (y) => _.findLastIndex(rowsTops, (value) => value <= y),
		isWedgePossible: () => !rowsTopsWedgeUnavailable[rowsAPI.last()],
		setNoWedge: () => {
			rowsTopsWedgeUnavailable[rowsAPI.last()] = true
		},
		markRowWithContent: () => {
			maxSpanByRow[rowsAPI.count()] = maxSpanByRow[rowsAPI.count()] || 1
		},
		createExtraRows: (rowStart, rowBottom) => {
			const currRowEnd = rowsAPI.count() + 1
			const compSpan = currRowEnd - rowStart
			const maxSpanInArea = _.max(_.times(compSpan, (n) => maxSpanByRow[rowStart + n] || 1))
			// @ts-ignore
			const rowsToAdd = _.max([isRowWithContent() ? 1 : 0, maxSpanInArea - compSpan + 1])
			// @ts-ignore
			if (!_.isUndefined(rowsLimit) && rowsTops.length + rowsToAdd >= rowsLimit) {
				throw new RowsLimitError()
			}

			// @ts-ignore
			const spanWithExtraRows = compSpan + rowsToAdd

			_.times(compSpan, (n) => (maxSpanByRow[rowStart + n] = spanWithExtraRows))
			// @ts-ignore
			_.times(rowsToAdd, () => {
				rowsAPI.closeRow(rowBottom)
				maxSpanByRow[rowsAPI.count()] = spanWithExtraRows
			})
		},
	}

	return rowsAPI
}
